export enum AREA_PERMISSIONS {
  AREA_VIEW = 'AREA_VIEW',
  AREA_WRITE = 'AREA_WRITE',
}
